import { EventType } from "../features/balancing/types/BalancingCore";
import { IdPersistence } from "./IdPersistence";
export var mapEventTypeToPersistenceKey = new Map([
    [EventType.CoopLeague, IdPersistence.CoopPreviousRanking],
    [EventType.PlayerLeague, IdPersistence.PlayerLeaguePreviousRanking],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapEventTypeToPersistenceKey.ts
// module id = 863
// module chunks = 3